import Wrapper from "./Wrapper";
import { useAssistantContext } from './Provider';
import DesktopPanel from './DesktopPanel';
import Mobile from './Mobile';

const Assistant = Wrapper;
export default Assistant;

export {
    Assistant,
    useAssistantContext,
    DesktopPanel,
    Mobile,
}
